import type { ReactElement } from 'react'

export const asReact17 = <P>(component: (props: P) => unknown) =>
  component as unknown as (props: P) => ReactElement | null
